import React, { useEffect, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { BiSubdirectoryRight } from "react-icons/bi";
import { apiGetProcesses, apiUpdateProcess } from "../../../api/ApiProcess";
import { useTranslation } from "react-i18next";

const ModalChoixProcesses = (props) => {
  const { t } = useTranslation();
  const { idOrgUnit, orgunitName, ReduxInstanceId, show, handleClose } = props;
  const [processes, setProcesses] = useState([]);

  const recupProcesses = async () => {
    const res = await apiGetProcesses(ReduxInstanceId, "filter=Macro");
    setProcesses(res.data);
  };

  const addRemoveProcess = async (idProcess) => {
    const processesCopy = [...processes];

    const index = processesCopy.findIndex((item) => item._id === idProcess);

    if (processesCopy[index].orgunits.includes(idOrgUnit)) {
      processesCopy[index].orgunits = processesCopy[index].orgunits.filter(
        (item) => item !== idOrgUnit
      );
    } else {
      processesCopy[index].orgunits.push(idOrgUnit);
    }

    const formData = { orgunits: processesCopy[index].orgunits };

    await apiUpdateProcess(processesCopy[index]._id, formData);
    setProcesses(processesCopy);
  };

  const RecursiveComponentLigneTableau = ({ objet, detailView, niveau }) => {
    let hasview = false;
    let enfantsIdentite = [];

    if (detailView) {
      hasview = true;
      //const bodyVue = detailView.body;

      // on cherche les process principaux de la vue
      const enfantsPrincipaux = [];
      for (const node of detailView) {
        if (node.data && node.data.template === 0) {
          enfantsPrincipaux.push(node.data.process);
        }
      }
      // on cherche dans les processes quel est le nom des process enfants
      enfantsPrincipaux.map((enfant) => {
        enfantsIdentite.push(
          processes.find((element) => element._id === enfant)
        );
      });
    }

    return (
      <>
        <div className="d-flex">
          {niveau !== 0 && (
            <BiSubdirectoryRight
              size="1.5em"
              className={"text-danger"}
              style={{ marginLeft: niveau * 15 + "px" }}
            />
          )}
          <Form.Check
            key={objet._id}
            id={"process_" + objet._id}
            type="switch"
            label={objet.nom}
            value={objet._id}
            onChange={(e) => {
              addRemoveProcess(e.target.value);
            }}
            checked={objet.orgunits.includes(idOrgUnit) ? "checked" : ""}
          />
        </div>

        {hasview &&
          enfantsIdentite.map((enfant) => (
            <RecursiveComponentLigneTableau
              key={enfant._id}
              objet={enfant}
              detailView={enfant.view}
              niveau={niveau + 1}
            />
          ))}
      </>
    );
  };

  useEffect(() => {
    if (show) {
      recupProcesses();
    }
  }, [show]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal show={show} onHide={handleClose} dialogClassName="modal-750px">
      <Modal.Header closeButton>
        <Modal.Title>
          {t("admin.PageAdminOrgunits.modalChoixProcessTitre") +
            " " +
            orgunitName}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {processes
          .filter((item) => item.famille === "MacroProcess")
          .map((process) => (
            <RecursiveComponentLigneTableau
              key={process._id}
              objet={process}
              detailView={process.view}
              niveau={0}
            />
          ))}
      </Modal.Body>
    </Modal>
  );
};

export default ModalChoixProcesses;
